// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleDek_root__1_tnX","ideasRoot":"ArticleDek_ideasRoot__okvtN"};